export default [
  {
    path: '/contacts',
    component: () => import('@/views/contacts/index.vue')
  }
]
